import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const GenerateQR = (username, secretKey) => {
    const qrCodeUrl = `otpauth://totp/MEDIEVAL:${username}?secret=${secretKey}&issuer=Medieval`;

    return (
        <div>
            {qrCodeUrl && <QRCodeSVG value={qrCodeUrl} size={256}/>}
        </div>
    );
};

export default GenerateQR;